/**
 * Product Gallery Carousel
 */

import Flickity from 'flickity';
import postArtwork from './post-artwork';

function productGalleryCarousel(opts) {
  const config = {
    dom: {
      gallery: '.js-product-gallery',
      carousel: 'js-product-gallery-carousel',
      post_artwork: 'js-post-artwork-image',
      post_artwork_wrapper: '.js-post-artwork-image',
      post_artwork_cell: '.js-uploaded-artwork',
      videoBtn: '.js-video-control',
    },
    flickityOpts: {
      prevNextButtons: false,
      pageDots: true,
      arrowShape: '',
      watchCSS: true, // mobile only
      wrapAround: true,
      cellSelector: '.js-product-gallery-carousel-cell',
    },
    cls: {
      selected: '.is-selected',
    },
  };

  const c = __.extend(config, opts);
  const $carousels = [...document.querySelectorAll(`.${c.dom.carousel}`)];

  const hasCurrentSpec = window.localStorage.getItem('currentFrameSpec') || false;

  /**
   * Init
   */
  function init() {
    if ($carousels && $carousels.length > 0) {
      $carousels.forEach(($carousel, idx) => {
        const $gallery = __.parents($carousel, c.dom.gallery)[0] || false;

        if (idx === 0 && $gallery) {
          arrangeImages($carousel, $gallery);
        } else {
          arrangeImages($carousel);
        }
      });
    }
  }

  function arrangeImages(carousel, gallery = false) {
    if (!carousel) return;
    const $postArtworkCells = carousel.querySelectorAll(c.dom.post_artwork_cell) || [];

    if ($postArtworkCells?.length > 0) {
      [...$postArtworkCells].forEach(($cell) => {
        if ($cell !== $postArtworkCells[0]) {
          $cell?.remove();
        } else {
          checkFrameSpecData($cell);
        }
      });
    }

    const $productImages = [...carousel.querySelectorAll(c.flickityOpts.cellSelector)];

    const $productImagesSorted = $productImages.sort((a, b) => {
      const aPriority = a.dataset.imagePriority;
      const bPriority = b.dataset.imagePriority;
      return aPriority - bPriority;
    });

    if ($productImagesSorted?.length > 0) {
      carousel.innerHTML = '';
      [...$productImagesSorted].forEach(($productImage, idx) => {
        $productImage.setAttribute('data-cell-index', idx);

        carousel.appendChild($productImage);
      });

      if (gallery) {
        __.removeClass(gallery, 'hide');
      }

      makeCarousel(carousel);
    } else {
      if (gallery) {
        __.removeClass(gallery, 'hide');
      }

      makeCarousel(carousel);
    }
  }

  /**
   * Check Frame Spec Data
   * @description checks if there is a current spec and initiates post artwork
   * @param {element} $cell
   * @returns {void}
   */
  function checkFrameSpecData($cell) {
    const { variantSpec } = $cell.dataset;

    if (!hasCurrentSpec && !variantSpec) {
      // if there is no current spec, remove the cell
      const $wrappers = [...document.querySelectorAll(c.dom.post_artwork_wrapper)];
      $wrappers.forEach(($wrapper) => {
        const $carouselCell = $wrapper?.parentNode || null;

        if ($carouselCell) {
          $carouselCell.remove();
        } else if (!$carouselCell && $wrapper) {
          $wrapper.remove();
        }
      });

      return;
    }

    postArtwork();
  }

  /**
   * Make carousel
   */
  function makeCarousel($carousel, destroyCarousel = false) {
    if (destroyCarousel) {
      const prev = Flickity.data($carousel);
      if (prev) {
        prev.destroy();
      }
    }
    // eslint-disable-next-line
    const flickityCarousel = new Flickity($carousel, c.flickityOpts);
    flickityCarousel.on('change', () => {
      const selectedIndex = $carousel.querySelector(c.cls.selected)?.dataset?.cellIndex;
      $carousel.nextElementSibling.setAttribute('data-cell-index', selectedIndex);
      const $videoBtns = [...$carousel.querySelectorAll(c.dom.videoBtn)];
      if ($videoBtns && $videoBtns.length > 0) {
        $videoBtns.forEach(($videoBtn) => {
          $videoBtn.setAttribute('tabindex', -1);
        });
      }
      const $selectedVideoBtns = [...$carousel.querySelectorAll(`[data-cell-index="${selectedIndex}"] ${c.dom.videoBtn}`)];
      if ($selectedVideoBtns && $selectedVideoBtns.length > 0) {
        $selectedVideoBtns.forEach(($selectedVideoBtn) => {
          $selectedVideoBtn.setAttribute('tabindex', 0);
        });
      }
    });
  }

  return {
    init,
    makeCarousel,
    arrangeImages,
  };
}

export default productGalleryCarousel;
